import { render, staticRenderFns } from "./verde-sys-green-logo.vue?vue&type=template&id=21725042&"
import script from "./verde-sys-green-logo.vue?vue&type=script&lang=js&"
export * from "./verde-sys-green-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports